import { findIndex } from 'lodash';

import './calendar-period.style.sass';
import template from './calendar-period.tpl.pug';

class CalendarPeriodController {
    $onInit() {
        this.selectedIndex = this.selectedIndex || 0;
    }

    $onChanges(changeObject) {
        if (changeObject.timestamp || changeObject.months) {
            this.selectedIndex = Math.max(findIndex(this.months || [], (month) => month.timestamp === this.timestamp), 0);
            this.selectedPosition = `${Number.prototype.toFixed.call(this.selectedIndex * 100 / 12, 2)}%`;
        }
    }

    select(month) {
        if (this.timestamp !== month.timestamp) {
            return this.onSelect({
                timestamp: month.timestamp
            });
        }
    }

    dismiss() {
        return this.onDismiss();
    }
}

export default {
    selector: 'dbACalendarPeriod',
    template: template(),
    controller: CalendarPeriodController,
    bindings: {
        loading: '<',
        timestamp: '<',
        months: '<',
        onSelect: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/component/calendar-period/calendar-period.cmpt.js